module.exports = __webpack_public_path__ + "static/media/LAC.70674181.svg";